import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useBlocker } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  clearAllBlockers,
  selectShouldBlockNavigation,
} from "@/redux/navigation/reducer";
import { NavigationBlockerProps } from "@/components_v2/Guards/types";

const NavigationBlocker = ({ message }: NavigationBlockerProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const shouldBlock = useSelector(selectShouldBlockNavigation);

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      shouldBlock && currentLocation.pathname !== nextLocation.pathname,
  );

  useEffect(() => {
    if (blocker.state === "blocked") {
      const proceed = window.confirm(message || t("navigationWarning"));

      if (proceed) {
        dispatch(clearAllBlockers());
        blocker.proceed();
      } else {
        blocker.reset();
      }
    }
  }, [blocker, message]);

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (shouldBlock) {
        e.preventDefault();
        e.returnValue = "";
        return "";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [shouldBlock]);

  return null;
};

export default NavigationBlocker;
